import { deleteRequest, getNoAuth, getRequest, host, patchRequest, postRequest, putRequest } from './apiService';
import { Role, User, UserWithName } from '../models/User';

const userApi = `${host}/api/user`;
const userRolesApi = `${host}/api/UserRoles`;

export async function fetchRoles(): Promise<Role[]> {
	return getRequest<Role[]>(`${userRolesApi}/available`);
}

export async function updateUserRoles(userId: string, roleIds: number[]): Promise<User> {
	return putRequest<User>(`${userRolesApi}/users/${userId}`, { roleIds });
}

export async function fetchUsers(): Promise<User[]> {
	return getRequest<User[]>(`${userApi}`);
}

export async function fetchDirectory(): Promise<UserWithName[]> {
	return getRequest<UserWithName[]>(`${userApi}/directory`);
}

export async function notifyStakeHolders(): Promise<string> {
	return postRequest<string>(`${userApi}/notify`);
}

export async function sync(): Promise<User> {
	return getRequest<User>(`${userApi}/sync`);
}

export async function ping(): Promise<boolean | string> {
	return getNoAuth<boolean | string>(`${userApi}/ping`);
}

export async function updateUserStatus(userId: string, active: boolean): Promise<void> {
	return patchRequest<void>(`${userApi}/${userId}/isActive/${active}`);
}

export async function deleteUser(userId: string): Promise<void> {
	return deleteRequest(`${userApi}/${userId}`);
}